const AddIcon = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.66667 11H14.3333M11 7.66667V14.3333M21 11C21 16.5229 16.5229 21 11 21C5.47716 21 1 16.5229 1 11C1 5.47716 5.47716 1 11 1C16.5229 1 21 5.47716 21 11Z"
        stroke="#5a5a5a"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default AddIcon;
